import React, { Fragment } from 'react';
import { Text } from 'react-native';
import { Device } from 'DeviceUtils';
import { useWebSearchContext } from 'Pages/Search/WebSearchContext';
import NavigationService from 'NavigationService';

import type { InfoItemValue } from '../../InfoList';
import getStyles from './styles';
import { useNavigationPropsContext } from '../../../../../../src/runtime/Navigation/navigationPropsContext';

interface InfoValuesProps {
    values: InfoItemValue[];
    isPlayerInfo: boolean;
    onNavigate?: () => void;
}

const InfoValues = ({ values, isPlayerInfo = false, onNavigate }: InfoValuesProps): JSX.Element => {
    const { isWeb } = Device;
    const { setSearchParams } = useWebSearchContext() as any;
    const { itemValueLink, itemValue } = getStyles({ isPlayerInfo });
    const { updateNavigationProps } = useNavigationPropsContext();

    const handleLinkClick = ({ link, value }) => {
        NavigationService.getAppNavigationInstance().navigate(link.route, {
            ...link.params,
            query: value,
            showSearchBox: !isWeb
        });
        if (isWeb) {
            updateNavigationProps({ query: value });
            setSearchParams({ query: value });
        }
        if (onNavigate && typeof onNavigate === 'function') onNavigate();
    };

    return (
        <>
            {values.map(({ value, link, children }, index) => {
                const fullName = typeof value === 'string' ? value : value.fullName;
                const key = `info-list-item-${index}-${fullName}`;
                return (
                    <Fragment key={key}>
                        <Text
                            style={link ? itemValueLink : itemValue}
                            onPress={(!!link && (() => handleLinkClick({ link, value }))) || undefined}
                        >
                            {fullName}
                            {children}
                        </Text>
                        {index + 1 < values.length && <Text style={itemValue}>, </Text>}
                    </Fragment>
                );
            })}
        </>
    );
};

export default React.memo(InfoValues);
